import { BillingSection } from '@/components/settings/billing-section.tsx'
import { StudentSubscriptionCard } from '@/components/settings/student-subscription-card.tsx'
import { StudentSubscriptionOffer } from '@/components/settings/student-subscription-offer.tsx'
import { useStudentSubscriptionPresenter } from '@/presenters/student-subscription.presenter.ts'

function Spinner() {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
    </div>
  )
}

export function StudentSubscriptionTab() {
  const presenter = useStudentSubscriptionPresenter()

  if (presenter.isLoading && !presenter.subscription) {
    return (
      <div className="flex w-full flex-col gap-8 pb-32 pt-4">
        <Spinner />
      </div>
    )
  }

  const isSubscribed = ['active', 'cancelled', 'suspended'].includes(
    presenter.subscription?.status ?? ''
  )

  return (
    <div className="bg-gray-25 mx-auto flex w-full max-w-6xl flex-col gap-12 pb-32 pt-4">
      {/* 1. Mise en avant de l'abonnement disponible */}
      <section>
        <StudentSubscriptionOffer
          clientSecret={presenter.clientSecret}
          subscriptionOpen={presenter.subscribeOpen}
          onSubscriptionOpenChange={presenter.setSubscribeOpen}
          onHandleSubscribe={(commitment) => {
            void presenter.handleSubscribe(commitment)
          }}
          isSubscribed={isSubscribed ?? false}
          isPending={presenter.isSubscribeLoading}
          promoCode={presenter.promotionalCodeOffer}
          invoicePrice={presenter.firstSubscriptionPrice}
          monthlyPrice={presenter.studentPlan?.price ?? null}
        />
      </section>

      {/* 2. Statut de l'abonnement */}
      <section className="px-6 sm:px-12 xl:px-0">
        {presenter.subscription && (
          <StudentSubscriptionCard
            subscription={presenter.subscription}
            onCancel={presenter.handleCancel}
            onRenew={presenter.handleRenew}
            onRePay={presenter.handleRePay}
            isActionLoading={presenter.isActionLoading}
            isLegacyPrice={
              presenter.subscription?.planId != null &&
              presenter.studentPlan !== undefined &&
              !presenter.studentPlan.currentPlanIds.includes(presenter.subscription.planId)
            }
          />
        )}
      </section>

      {/* 3. Facturation & paiements */}
      <section className="px-6 sm:px-12 xl:px-0">
        <BillingSection
          invoices={presenter.invoices}
          payments={presenter.payments}
          onDownload={presenter.handleDownloadInvoice}
        />
      </section>
    </div>
  )
}
